import React from 'react';
import { AnimateOnScroll } from '../AnimateOnScroll';
export function LHResults() {
  return <section className="bg-[#ECECEC] py-[60px] lg:py-[100px]" data-id="element-1622">
      <div className="max-w-[800px] mx-auto px-6 lg:px-8" data-id="element-1623">
        <AnimateOnScroll className="text-center flex flex-col items-center" data-id="element-1624">
          <span className="text-[#FF1493] uppercase text-sm font-bold tracking-[3px] mb-4 font-[Poppins,_sans-serif]" data-id="element-1625">
            Be MESMERIZING
          </span>

          <h2 className="text-[26px] lg:text-[40px] uppercase text-black leading-tight mb-6 font-[600] font-[Poppins,_sans-serif]" data-id="element-1626">
            WHAT ARE THE EXPECTED RESULTS?
          </h2>

          <div className="w-[40px] h-[2px] bg-[#FF1493] mb-8" data-id="element-1627"></div>

          <div className="space-y-6 text-[#333333] text-[17px] leading-[1.8] font-body" data-id="element-1628">
            <p data-id="element-1629">
              Results from laser hair reduction include a gradual reduction in
              hair thickness and density, leading to smoother and hair-free
              skin.
            </p>
            <p data-id="element-1630">
              While multiple sessions are usually required, many individuals
              experience a significant reduction in unwanted hair after just a
              few treatments.
            </p>
            <p data-id="element-1631">
              Laser hair removal results are different for everyone. You can
              expect slower regrowth and softer, finer hair. Within the first
              few sessions, some of your hair will stop growing back completely,
              and you'll see patchiness in any regrowth you experience. With
              more sessions, results will continue to improve. Some individuals
              may experience long-term hair loss, while others may require
              occasional maintenance sessions to keep the hair at bay.
            </p>
          </div>
        </AnimateOnScroll>
      </div>
    </section>;
}